import { render, staticRenderFns } from "./JobMetadataUpdater.vue?vue&type=template&id=787a5b60&scoped=true&"
import script from "./JobMetadataUpdater.vue?vue&type=script&lang=ts&"
export * from "./JobMetadataUpdater.vue?vue&type=script&lang=ts&"
import style0 from "./JobMetadataUpdater.vue?vue&type=style&index=0&id=787a5b60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787a5b60",
  null
  
)

export default component.exports